module.exports = __webpack_public_path__ + "home.178abe594448d8c52e29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/home.jpg
// module id = 1458
// module chunks = 2